
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class vPagination extends Vue {

  activePage = 1;

  @Prop() totalResults!: number;
  @Prop() resultsPerPage!: number;
  @Prop() numVisiblePages?: number;
  @Prop() outerPage!: number;

  @Watch('outerPage')
  onOuterPageChanged(val: number) {
    this.activePage = val;
  }

  backSymbol = "<";
  nextSymbol = ">";

  get numPages() {
    return Math.ceil(this.totalResults / this.resultsPerPage);
  }

  get disabledPrev() {
    return this.activePage === 1;
  }

  get disabledNext() {
    return this.activePage === this.numPages;
  }

  range(min: number, max: number) {
    const array = [];
    let j = 0;

    for (let i = min; i <= max; i++) {
      array[j] = i;
      j++;
    }
    return array;
  }

  isActive(page: number) {
    return this.activePage === page;
  }

  setPage(page: number) {
    this.activePage = page;
    this.fetchPage();
  }

  nextPage() {
    if (!this.disabledNext) {
      this.activePage++;
      this.fetchPage();
    }
  }

  prevPage() {
    if (!this.disabledPrev) {
      this.activePage--;
      this.fetchPage();
    }
  }

  fetchPage() {
    this.$emit("changePage", this.activePage);
  }
}
